import mainLocale from './main-locale';
import supportedLocales from './supported-locales';

export default {
  mainLocale,
  supportedLocales,
};
